export class SerializedEventQueue {
    private events: (() => void)[] = [];
    private stop = false;
    private idleCallback;
    private timerCallback;

    constructor() {
        this.cycle();
    }

    destroy() {
        this.stop = true;
        window.cancelIdleCallback(this.idleCallback);
        window.clearTimeout(this.timerCallback);
        this.events = undefined;
    }

    private cycle() {
        if (this.stop)
            return;

        if (this.events.length > 0) {
            const event = this.events.splice(0, 1)[0];
            event();
            this.idleCallback = window.requestIdleCallback(() => this.cycle(), {timeout: 100});
        } else {
            this.timerCallback = setTimeout(() => {
                this.idleCallback = window.requestIdleCallback(() => this.cycle(), {timeout: 100});
            }, 300);
        }
    }

    add(action: () => void){
        if (this.events)
            this.events.push(action);
    }
}